import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';

function ForgotPassword() {
  const navigate = useNavigate();

  const [step, setStep] = useState('phone'); // phone | otp | new-password | success
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost/backend';

  // ارسال کد بازیابی
  const handleSendCode = async (e) => {
    e.preventDefault();
    setError('');

    if (!phone.match(/^09[0-9]{9}$/)) {
      setError('شماره موبایل نامعتبر است');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${apiUrl}/api/auth/forgot-password.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone }),
      });

      const data = await response.json();

      if (data.success) {
        setStep('otp');
        if (data.dev_code) {
          alert(`کد بازیابی (تست): ${data.dev_code}`);
        }
      } else {
        setError(data.error || 'خطا در ارسال کد');
      }
    } catch (err) {
      setError('خطا در ارتباط با سرور');
    } finally {
      setLoading(false);
    }
  };

  // تأیید کد و رفتن به مرحله رمز جدید
  const handleVerifyCode = (e) => {
    e.preventDefault();
    setError('');

    if (otp.length !== 6) {
      setError('کد باید 6 رقم باشد');
      return;
    }

    setStep('new-password');
  };

  // تنظیم رمز عبور جدید
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 6) {
      setError('رمز عبور باید حداقل 6 کاراکتر باشد');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('رمز عبور و تکرار آن یکسان نیستند');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${apiUrl}/api/auth/reset-password.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone,
          code: otp,
          new_password: newPassword,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setStep('success');
      } else {
        setError(data.error || 'خطا در تغییر رمز عبور');
      }
    } catch (err) {
      setError('خطا در ارتباط با سرور');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>🔑 بازیابی رمز عبور</h1>
          <p>
            {step === 'phone' && 'شماره موبایلت رو وارد کن'}
            {step === 'otp' && 'کد تأییدی که برات فرستادیم رو وارد کن'}
            {step === 'new-password' && 'یک رمز عبور جدید انتخاب کن'}
            {step === 'success' && 'رمز عبور با موفقیت تغییر کرد!'}
          </p>
        </div>

        {error && (
          <div className="error-message">
            <span>⚠️</span>
            <p>{error}</p>
          </div>
        )}

        {/* مرحله 1: شماره موبایل */}
        {step === 'phone' && (
          <form onSubmit={handleSendCode} className="login-form">
            <div className="form-group">
              <label>شماره موبایل</label>
              <input
                type="tel"
                placeholder="09123456789"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                maxLength={11}
                disabled={loading}
                autoFocus
              />
              <small>کد بازیابی به این شماره ارسال می‌شه</small>
            </div>

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'در حال ارسال...' : 'ارسال کد بازیابی'}
            </button>

            <button
              type="button"
              className="btn-secondary"
              onClick={() => navigate('/login')}
            >
              بازگشت به صفحه ورود
            </button>
          </form>
        )}

        {/* مرحله 2: کد تأیید */}
        {step === 'otp' && (
          <form onSubmit={handleVerifyCode} className="login-form">
            <div className="form-group">
              <label>کد تأیید</label>
              <input
                type="text"
                placeholder="کد 6 رقمی"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                maxLength={6}
                disabled={loading}
                autoFocus
              />
              <small>کد به {phone} ارسال شد</small>
            </div>

            <button type="submit" className="btn-primary">
              تأیید و ادامه
            </button>

            <button
              type="button"
              className="btn-secondary"
              onClick={() => setStep('phone')}
            >
              تغییر شماره
            </button>
          </form>
        )}

        {/* مرحله 3: رمز عبور جدید */}
        {step === 'new-password' && (
          <form onSubmit={handleResetPassword} className="login-form">
            <div className="form-group">
              <label>رمز عبور جدید</label>
              <input
                type="password"
                placeholder="حداقل 6 کاراکتر"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                disabled={loading}
                autoFocus
              />
            </div>

            <div className="form-group">
              <label>تکرار رمز عبور</label>
              <input
                type="password"
                placeholder="تکرار رمز عبور"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                disabled={loading}
              />
            </div>

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'در حال تنظیم...' : 'تنظیم رمز عبور جدید'}
            </button>
          </form>
        )}

        {/* مرحله 4: موفقیت */}
        {step === 'success' && (
          <div className="success-section">
            <div className="success-icon">✅</div>
            <h2>رمز عبور تغییر کرد!</h2>
            <p>حالا می‌تونی با رمز عبور جدید وارد شی</p>

            <button
              className="btn-primary"
              onClick={() => navigate('/login')}
              style={{ marginTop: '30px' }}
            >
              رفتن به صفحه ورود
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;